import { render, staticRenderFns } from "./WarningsSettings.vue?vue&type=template&id=7f64f5fa&scoped=true"
import script from "./WarningsSettings.vue?vue&type=script&lang=js"
export * from "./WarningsSettings.vue?vue&type=script&lang=js"
import style0 from "./WarningsSettings.vue?vue&type=style&index=0&id=7f64f5fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f64f5fa",
  null
  
)

export default component.exports